const DEFAULT_OPTIONS = {
  // can be 'error', 'success' or 'blank'
  appearance: 'error',
};

// eslint-disable-next-line import/prefer-default-export
export { DEFAULT_OPTIONS };
